<template>
  <div class="uesrmanage">
       <!-- <div class="user-bar">
              <div @click="userBar_index = 1" :class="[userBar_index == 1 ? 'selectbar':'notSelect']">业务员</div>
              <div @click="userBar_index = 0" :class="[userBar_index == 0 ? 'selectbar':'notSelect']">普通用户</div>
       </div> -->
       <div class="user-content">
              <div class="merch">
                     <div class="up-merch">
                            <div @click="isShowData = true">单条上传</div>
                            <label for="fileInput" class="excel-up">excel上传</label>
                            <div @click="del_repeat">去重</div>
                            <div @click="up_dis_price">业务员价格</div>
                     </div>
                     <!-- <div class="change-excel" v-if="fileName"><span>文件名:{{fileName}}</span><Icon name="cross" color='red' @click="clearExcel"/></div> -->
                     <input v-if="showFileInput"  type="file" accept=".xls,.xlsx" @change="handleFileUpload" class="fileUploader" id="fileInput"/>
                     
                     <div class="user-update" v-if="isShowData">
                            <div><Field label="姓名:" placeholder="请输入业务员姓名" v-model="createUser.userName"/></div>
                            <div><Field label="电话:" placeholder="请输入业务员电话" v-model="createUser.phoneNum"/></div>
                            <div class="up-btn">
                                   <Button plain hairline type="danger" size="small" @click="closeUp">取消</Button>
                                   <Button plain hairline type="success" size="small" @click="submitUser">确认</Button>
                            </div>
                     </div>
              </div>
              <div class="uesr-list">
                     <ul>   
                            <li v-for="(item,i) in userList" :key="i">
                                   <div>{{item.uname}}:  {{item.phone}}</div>
                                   <div @click="del_user(item)">删除</div>
                            </li>
                     </ul>
              </div>
       </div>
       <Overlay :show='fileName.length>0'>
              <div class="excel-info">
                     <div class="excel-bar">
                            <span>上传数据</span>
                            <Icon name="cross" class="close-excel" @click="clearExcel"/>
                     </div>
                     <div class="total-execl">共:{{excelData.length}} 条数据</div>
                     <ul>
                            <li v-for="(item,i) in excelData" :key="i">
                                   <div v-for="(items,a) in item" :key="a">
                                          {{ a==0? '姓名':'电话' }}: {{items}}
                                   </div>
                            </li> 
                     </ul>
                     <Button type="primary" size="large" class="sub-excel" :loading="query_loading"  native-type="submit" loading-text="查询中..." @click="subExcel">上传</Button>
              </div>
       </Overlay>
  </div>
</template>
<script setup>
// create_user
import { create_user, getuerType, delUser,delRepeat, getDisPrice,upDisPrice} from '@/api/index'
import { FloatingBubble, RadioGroup, Radio, Overlay, Icon, showLoadingToast,Button, showToast, Field, showConfirmDialog } from 'vant';
import { computed, getCurrentInstance, onMounted,  ref, nextTick } from "vue";
import * as XLSX from 'xlsx';
const userBar_index = ref(1) //1为业务员
const isMerch = ref(true)
const fileName = ref('')
const excelData = ref([])
const fileInputRef = ref(null);
const showFileInput = ref(true)
const userList = ref([])
const isShowData = ref(false) //单条上传
const createUser = ref({
       userName:'',
       phoneNum:''
})
const createMerch = async () => {
}
onMounted(()=>{
      getUer_type() 
})
// 业务员excel上传
const handleFileUpload = async (event) =>{
       let excel_data_loading = showLoadingToast({
              message: 'excel解析中...',
              loadingType: 'spinner',
              duration:0
       });
       const file = event.target.files[0];
       const reader = new FileReader();
       fileName.value = file.name;
       reader.onload = (e) => {
              const data = new Uint8Array(e.target.result);
              const workbook = XLSX.read(data, { type: 'array' });
              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];
              const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
              // 处理jsonData，例如将其存储到Vuex或者状态中
              const filteredData = jsonData.filter(row => row.length > 0);
              const cleanedData = filteredData.map(row => row.filter(field => field !== ""));
              let trimmedData = filteredData.slice(1);
              trimmedData = trimmedData.map(row => row.slice(0));
              excel_data_loading.close()
              excelData.value = trimmedData
       };
       reader.readAsArrayBuffer(file);
}
// 清空excel表格
const clearExcel =async () =>{
       fileName.value = ''
       excelData.value = []
       await nextTick()
       showFileInput.value = false
       setTimeout(()=>{
              showFileInput.value = true
       },500)
}
// 确定上传excel
const subExcel = async ()=>{
       let excel_data_loading = showLoadingToast({
              message: '上传中...',
              loadingType: 'spinner',
              duration:0
       });
       let res = await create_user({excelData:JSON.stringify(excelData.value)})
       excel_data_loading.close()
       if(res.status == 200){
              getUer_type()
              showToast('上传成功')
              clearExcel()
       }
}
// 分类获取用户
const getUer_type = async () => {
       let res = await getuerType({type:userBar_index.value})
       userList.value = res.data
}
// 删除业务员
const del_user = async (e) =>{
       showConfirmDialog({
              title: '删除',
              message:'删除用户后将无法恢复,是否确认',
       })
       .then(async () => {
              let load = showLoadingToast({
                     message: '删除中',
                     loadingType: 'spinner',
                     duration:0
              });
              let res = await delUser({uid:e.uid})
              load.close()
              if(res.data == 1){
                     await getUer_type()
                     showToast('删除成功')
              }
       })
       .catch(() => {
       });

   
}
// 单条创建业务员
const submitUser =async () => {
       console.log(createUser.value)
       let { userName, phoneNum } = createUser.value
       if(userName.length == 0){
              showToast('业务员姓名不能为空')
              return
       }
       if(phoneNum.length == 0 || phoneNum.length != 11){
              showToast('业务员电话有误,请重新输入')
              return
       }
       let data = [[userName,phoneNum]]
       excelData.value = data 
       createUser.value = {
              userName:'',
              phoneNum:''
       }
       await subExcel()
       isShowData.value = false
}
// 去除重复数据
const del_repeat = async () => {
       let load = showLoadingToast({
              message: '删除中',
              loadingType: 'spinner',
              duration:0
       });
       await delRepeat()
       setTimeout(async()=>{
              await getUer_type()
              load.close()
       },1500)
}
// 取消
const closeUp = async () =>{
       createUser.value = {
              userName:'',
              phoneNum:''
       }
       isShowData.value = false
}
// 修改业务员价格
const up_dis_price = async () =>{
       let price_res = await getDisPrice()
       let res = prompt('当前价格业务员购买优惠码的价格是:'+price_res.data.disprice+ '元')
       if(res){
              let up_res = await upDisPrice({dis_price:res})
              showToast('修改成功')
       }
}
</script>
<style lang="less" scoped>
       .uesrmanage{
              height: calc(100vh - 160px);
              padding: 0px 40px 0px 40px;
       }
       .user-bar{
              width: 100%;
              display: flex;
              >div{
                     padding:3px 15px;
                     font-size: 15px;
                     margin-left: 15px;
                     border-radius: 8px;
                     box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.1),-5px -5px 10px rgba(0, 0, 0, 0.1);
                     cursor: pointer;
              }
              .notSelect{
                     color: black;
                     border: 1px solid rgba(22, 22, 245, 0.3);
              }
              .selectbar{
                     color: #fff;
                     background: rgba(22, 22, 245, 0.3);
              }
       }
       .user-content{
              height: calc(100vh - 190px);
       }
       .up-merch{
              display: flex;
              padding: 13px;
              div,.excel-up{
                     padding: 3px 12px;
                     border: 8px;
                     font-size: 12px;
                     color: rgba(22, 22, 245, 0.3);
                     border: 1px solid rgba(22, 22, 245, 0.3);
                     box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.1),-5px -5px 10px rgba(0, 0, 0, 0.1);
                     margin-left: 12px;
                     border-radius: 8px;
                     cursor: pointer;
              }
       }
       .fileUploader {
              position: absolute;
              width: 1px;
              height: 1px;
              padding: 0;
              margin: -1px;
              overflow: hidden;
              clip: rect(0, 0, 0, 0);
              white-space: nowrap;
              border: 0;
       }
       .change-excel{
              display: flex;
              align-items: center;
              font-size: 15px;
              padding-left: 26px;
              color: #b1b1b1;
              span{
                     margin-right: 6px;
                     text-decoration: underline;
              }
       }
       .excel-info{
              width:820px;
              height: 600px;
              background: #fff;
              border-radius: 15px;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%,-50%);
              overflow: hidden;
              .excel-bar{
                     text-align: center;
                     padding: 16px 0px;
                     border-bottom: 1px solid #b1b1b1;
                     font-size: 22px;
                     font-weight: bold;
                     position: relative;
                     .close-excel{
                            position: absolute;
                            right: 15px;
                     }
              }
              .total-execl{
                     font-size: 13px;
                     color: #ddd;
                     margin:7px 0px 0px 15px;
              }
              ul{
                     display: grid;
                     grid-template-columns: repeat(3, 1fr);
                     column-gap: 25px;
                     row-gap: 20px;
                     padding: 7px 15px 65px 15px;
                     justify-content: space-between;
                     max-height: 520px;
                     overflow: auto;
              }
              li{
                     display: flex;
                     align-items: flex-start;
                     font-size: 15px;
                     width: 240px;
                     justify-content: space-between;
                     margin-bottom: 5px;
                     border-bottom: 1px solid #ddd;
                     white-space: nowrap;
              }
       }
       .sub-excel{
              width: 65px;
              height: 35px;
              position: absolute;
              right: 15px;
              bottom: 15px;
       }
       .uesr-list{
              height: 98%;
              ul{
                     display: grid;
                     grid-template-columns: repeat(4, 1fr);
                     column-gap: 25px;
                     row-gap: 20px;
                     >li:hover{
                            background: #ddd;
                     }
                     li{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            font-size: 18px;
                            border-bottom: 1px #b1b1b1 solid;
                            >div{
                                   white-space: nowrap;
                            }
                            >div:first-of-type{
                                   width: 210px;
                            }
                            >div:last-of-type{
                                   color: red;
                                   cursor: pointer;
                            }
                     }
                     
              }
       }
       .user-update{
              display: flex;
              align-items: center;
              font-size: 20px;
              border-bottom: 1px solid #b1b1b1;
              justify-content: space-between;
              margin-bottom: 15px;
              padding-bottom: 13px;
              >div{
                     display: flex;
                     align-items: center;
                     white-space: nowrap;
              }
       }
       .up-btn{
              display: flex;
              >button{
                     margin-left: 15px;
              }
       }
</style>